import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import CustomList from './CustomList';
import { Tooltip } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        margin: 'auto'
    },
    paper: {
        padding: theme.spacing(3),
        textAlign: 'center',
    },
    button: {
        margin: theme.spacing(0.5, 0),
    },
}));

function not(a, b) {
    return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
    return a.filter((value) => b.indexOf(value) !== -1);
}

export default function TransferList(props) {
    const classes = useStyles();
    const [checked, setChecked] = React.useState([]);
    const [left, setLeft] = React.useState(props.left);
    const [right, setRight] = React.useState(props.right);

    React.useEffect(() => {
        if (!left || !right) {
            if (props.right) {
                setRight(props.right)
            }
            if (props.left) {
                setLeft(props.left)
            }
        }
    }, [props, left, right]);

    React.useEffect(() => {
        props.setResult(right);
    }, [right]);

    const leftChecked = intersection(checked, left);
    const rightChecked = intersection(checked, right);

    const handleToggle = (value) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }
        setChecked(newChecked);
    };

    const handleAllRight = () => {
        setRight(right.concat(left));
        setLeft([]);
    };

    const handleCheckedRight = () => {
        setRight(right.concat(leftChecked));
        setLeft(not(left, leftChecked));
        setChecked(not(checked, leftChecked));
    };

    const handleCheckedLeft = () => {
        setLeft(left.concat(rightChecked));
        setRight(not(right, rightChecked));
        setChecked(not(checked, rightChecked));
    };

    const handleAllLeft = () => {
        setLeft(left.concat(right));
        setRight([]);
    };

    return (
        <div id="main-transferlist-container">
            <div id="buttons-container">
                <Tooltip title="Mindet jobbra">
                    <span>
                        <Button
                            variant="outlined"
                            size="small"
                            className={classes.button + " move-button"}
                            onClick={handleAllRight}
                            disabled={left && left.length === 0}
                            aria-label="move all right"
                        >
                            ≫
                        </Button>
                    </span>
                </Tooltip>
                <Tooltip title="Kijelöltek jobbra">
                    <span>
                        <Button
                            variant="outlined"
                            size="small"
                            className={classes.button + " move-button"}
                            onClick={handleCheckedRight}
                            disabled={leftChecked.length === 0}
                            aria-label="move selected right"
                        >
                            &gt;
                        </Button></span></Tooltip>
                <Tooltip title="Kijelöltek balra">
                    <span>
                        <Button
                            variant="outlined"
                            size="small"
                            className={classes.button + " move-button"}
                            onClick={handleCheckedLeft}
                            disabled={rightChecked.length === 0}
                            aria-label="move selected left"
                        >
                            &lt;
                        </Button></span></Tooltip>
                <Tooltip title="Mindet balra">
                    <span>
                        <Button
                            variant="outlined"
                            size="small"
                            className={classes.button + " move-button"}
                            onClick={handleAllLeft}
                            disabled={right.length === 0}
                            aria-label="move all left"
                        >
                            ≪
                        </Button></span></Tooltip>
            </div>
            <div id="tables-container">
                <CustomList items={left} checked={checked} full={false} handleToggle={handleToggle} className="left-table" title="Nem kell" />
                <CustomList items={right} checked={checked} full={true} handleToggle={handleToggle} className="right-table" title="PDF tartalma" />
                {/* <Grid container spacing={3} className={classes.root}>
                    <Grid item xs>Nem kell<CustomList items={left} checked={checked} full={false} handleToggle={handleToggle} /></Grid>
                    <Grid item xs={8}>Utalandó<CustomList items={right} checked={checked} full={true} handleToggle={handleToggle} /></Grid>
                </Grid> */}
            </div>
        </div>
    );
}

